<template>
  <div
    class="content"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/images/PTTSymmetryOscura02.jpg') + ')'
    }"
  >
    <div id="login">
      <div class="container">
        <div
          id="login-row"
          class="row justify-content-center align-items-center"
        >
          <div id="login-column" class="col-md-6">
            <div id="login-box" class="col-md-12">
              <p
                class="lead mt-3"
                style="text-align: center;color: var(--textactive-2)"
              >
                ENTER NEW PASSWORD
              </p>
              <span>
                <p class="text__error" :class="{ actived: isError }">
                  {{ errorMsg }}
                </p>
              </span>
              <form @submit.prevent="handleSubmit">
                <div class="form-group" style="text-align: center;">
                  <label
                    for="password"
                    class="text-info text-title text-title-wg"
                    >New password*:</label
                  ><br />
                  <input
                    type="password"
                    v-model="password"
                    v-validate="{ required: true, min: 8 }"
                    name="password"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && errors.has('password')
                    }"
                  />
                  <div
                    v-if="submitted && errors.has('password')"
                    class="invalid-feedback"
                  >
                    {{ errors.first("password") }}
                  </div>
                  <ul class="text-title-wg">
                    <li>
                      Your password can't be too similar to yout other personal
                      information.
                    </li>
                    <li>Your password must contain at least 8 characters</li>
                    <li>Your password can't be a commonly used password</li>
                    <li>Your password can't be entirily numeric</li>
                  </ul>
                </div>
                <div class="form-group" style="text-align: center;">
                  <label
                    for="username"
                    class="text-info text-title text-title-wg"
                    >New password confirmation*:</label
                  ><br />
                  <input
                    type="password"
                    v-model="password_confirmation"
                    v-validate="{ required: true, min: 8 }"
                    name="password_confirmation"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && errors.has('password')
                    }"
                  />
                  <div
                    v-if="submitted && errors.has('password_confirmation')"
                    class="invalid-feedback"
                  >
                    {{ errors.first("password_confirmation") }}
                  </div>
                </div>
                <div class="form-group" style="text-align: center;">
                  <button
                    class="btn btn-home-drk"
                    style="width: 200px"
                    :disabled="loggingIn"
                  >
                    Change password
                  </button>
                  <img
                    v-show="loggingIn"
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
                  />
                </div>
                <div class="form-group" style="text-align: center;">
                  <router-link
                    :to="{ name: 'login' }"
                    class="text-info text-link"
                    style="padding-right: 0"
                  >
                    <span class="text-info text-title-wg text-link"
                      >Or go back to login</span
                    ></router-link
                  ><br />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from "../../_services";
import router from "../../router";
export default {
  data() {
    return {
      errorMsg: "",
      isError: false,
      username: "",
      password: "",
      password_confirmation: "",
      submitted: false,
      logo_white: require("@/assets/images/logo_white.png"),
      logo_blue: require("@/assets/images/logo_blue.png"),
      logo: require("@/assets/images/logo_white.png")
    };
  },
  computed: {
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    }
  },
  created() {
    document.title = "Login | Quanspire";
  },
  methods: {
    handleSubmit() {
      this.submitted = false;
      this.$validator.validate().then(valid => {
        if (valid) {
          var user = {
            pk_idusers: this.$route.params.id,
            password: this.password,
            password_confirmation: this.password_confirmation
          };
          apiService
            .setRessetPassword(user)
            .then(data => {
              this.isError = false;
              console.log("response", data);
              router.push("/login");
            })
            .catch(error => {
              this.isError = true;
              this.errorMsg = error.response.data.password;
              console.error(error);
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.text__error {
  display: none;
}
.text__error.actived {
  display: block;
}
</style>
